import Module from "./module";
import List from "./list";
import Entity from "./entity";
import Api from "./api";
import { getIcons } from "../utils";
import IModule from "../interface/module";
import IList from "../interface/list";
import IEntity from "../interface/entity";
import ICardList from "../interface/card-list";
import IApiEntity from "../interface/api/api-entity";
import Global from "../global";
import ErrorCode from "../enum/error-code";
import CardType from "../enum/card-type";
import ModuleCardBase from "../class/module-card-base";

class ModuleCardListInstance extends ModuleCardBase {

    public CardType: CardType = CardType.List;

    public async onCreate(card: ICardList): Promise<ICardList> {
        const list: IList = await List.create(card.entityId as number, card.label);
        card.listId = list.id as number;
        return card;
    }

    public async onUpdate(card: ICardList, existed: ICardList): Promise<ICardList> {
        card.listId = existed.listId;
        return card;
    }

    public async onDelete(card: ICardList): Promise<void> {
        await List.delete(card.listId);
    }

    public async onClone(card: ICardList): Promise<ICardList> {
        const list: IList = await List.clone(card.listId) as IList;
        card.listId = list.id as number;
        return card;
    }

    public toClient(card: ICardList): ICardList | null {
        const list: IList | null = List.get(card.listId);
        if (list) {
            const entity: IApiEntity = Api.getEntity(list.entityId) as IApiEntity;
            card.entityId = entity.id;
            card.lastEdited = entity._ts;
            return card;
        }
        return null;
    }

    public toServer(card: ICardList): ICardList {
        return {
            id: card.id,
            type: CardType.List,
            label: card.label,
            moduleId: card.moduleId,
            listId: card.listId,
            icon: card.icon
        };
    }

    public valid(card: ICardList): boolean {
        card.label = card.label.trim();
        return !!card.label;
    }

    public getListId(card: ICardList): number | null {
        return card.listId;
    }

    public async createByEntityId(entityId: number, moduleId: number = 0): Promise<ICardList> {
        const entity: IEntity | null = Entity.get(entityId);
        if (entity) {
            const icon: string = getIcons(entity.singular)[0] || Global.DEFAULT_TABLE_ICON;
            if (moduleId) {
                const module: IModule | null = Module.get(moduleId);
                if (!module) {
                    moduleId = Module.getDefault().id as number;
                }
            } else {
                moduleId = Module.getDefault().id as number;
            }
            return await this.create({
                label: entity.singular,
                type: CardType.List,
                entityId: entityId,
                listId: 0,
                moduleId,
                icon
            }) as ICardList;
        } else {
            throw ErrorCode.BadArguments;
        }
    }

}

const ModuleCardList = new ModuleCardListInstance();

export default ModuleCardList;